import styled from "styled-components";
import { Typography } from "antd";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 1px 3px ${({ theme }) => theme.colors.cardShadow};
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 24px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
  flex-shrink: 0;
`;

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 4px;
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  .ant-tabs { flex: 1; min-width: 0; }
  .ant-tabs-nav { margin-bottom: 0 !important; }
  .ant-tabs-nav::before { border-bottom: none !important; }
  .ant-tabs-tab .ant-tabs-tab-btn { font-size: 14px; font-weight: 500; }
`;

export const ContentSection = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const DrawerClosedSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px 24px;
`;

export const PlaceholderText = styled(Typography.Text)`
  color: ${({ theme }) => theme.colors.textSecondary ?? "#8c8c8c"};
  font-size: 14px;
`;
